import CarouselRepository from "../CarouselRepository"

export default class WhyPodiemCarousel extends CarouselRepository {
    static schemaId = "why_us_carouselDetailed"

    constructor() {
        super(WhyPodiemCarousel.schemaId)
    }
}
